/* eslint-disable camelcase */
/**
 * @author Fernando Ruano
 * @file index.js
 * @description Parameter Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { parameter: parameterEndpoints } = endpoints;

export class ParameterService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Get parameters list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get parameters list.
   */
  getParameters = async (paged, limit, page) => {
    const queryParam = `?limit=${limit}&page=${page}&paged=${paged}`;
    let url = parameterEndpoints.base;
    if (paged) {
      url = `${url}${queryParam}`;
    }
    return this.http.get(url);
  };

  /**
   * Get parameter info by id
   * @param { string } id - Parameter id.
   * @return { Object } - Get parameter.
   */
  getParameterById = async (id) => {
    const url = `${parameterEndpoints.base}/${id}`;
    return this.http.get(url);
  };

  /**
   * Get parameter info by id
   * @param { string } parameterKey - Parameter key.
   * @return { Object } - Get Parameter.
   */
  getParameterByKey = async (parameterKey) => {
    const url = `${parameterEndpoints.findByKey}/${parameterKey}`;
    return this.http.get(url);
  };

  /**
   * Delete parameter by id
   * @param { string } id - Parameter id.
   * @return { Object } - Get parameters list.
   */
  deleteParameterById = async (id) => {
    const url = `${parameterEndpoints.base}/${id}`;
    return this.http.delete(url);
  };

  /**
   * Create parameter
   * @param { string } name - Parameter name.
   * @param { string } description - Parameter description.
   * @return { promise } - The parameter promise object.
   */
  createParameter = async (param_key, param_value, param_description) => {
    const body = { param_key, param_value, param_description };
    const url = parameterEndpoints.base;
    return this.http.post(url, body);
  };

  /**
   * Update parameter
   * @param { string } name - Parameter name.
   * @param { string } description - Parameter description.
   * @param { string } id - Parameter id.
   * @return { promise } - The parameter promise object.
   */
  updateParameter = async (param_key, param_value, param_description, id) => {
    const body = { param_key, param_value, param_description };
    const url = `${parameterEndpoints.base}/${id}`;
    return this.http.update(url, body, {}, 'put');
  };
}

export default new ParameterService(externalConnector);
